import React from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import MethodBadge from "./MethodBadge";

const SidebarCategory = ({ category }) => {
  const { expandedCategories, toggleCategory, selectedEndpointId, setSelectedEndpointId } =
    useApiDocsContext();

  const isExpanded = expandedCategories.includes(category.file);
  const endpoints = category.endpoints || [];

  if (endpoints.length === 0) return null;

  return (
    <div className="api-docs-category">
      <button
        className="api-docs-category-header"
        onClick={() => toggleCategory(category.file)}
        aria-expanded={isExpanded}
      >
        <span className="api-docs-category-name">
          {category.name}
          {category.admin && <span className="api-docs-category-badge api-docs-category-badge--admin">ADMIN</span>}
          {category.public_api && <span className="api-docs-category-badge api-docs-category-badge--public">PUBLIC</span>}
        </span>
        <span className={`api-docs-chevron ${isExpanded ? "api-docs-chevron--open" : ""}`}>
          &#9656;
        </span>
      </button>
      {isExpanded && (
        <ul className="api-docs-endpoint-list">
          {endpoints.map((endpoint) => (
            <li key={endpoint.id}>
              <button
                className={`api-docs-endpoint-link ${
                  selectedEndpointId === endpoint.id ? "api-docs-endpoint-link--active" : ""
                }`}
                onClick={() => setSelectedEndpointId(endpoint.id)}
              >
                <MethodBadge method={endpoint.method} size="small" />
                <span className="api-docs-endpoint-summary">{endpoint.summary}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SidebarCategory;
